var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.064,
    height: 25,
    viewBox: "0 0 26.064 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2223",
    "data-name": "Ret\\xE2ngulo 2223",
    width: 26.064,
    height: 25,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1123",
    "data-name": "Grupo 1123",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_792",
    "data-name": "Caminho 792",
    d: "M51.875,30.947H49V47.716h2.874a.756.756,0,0,0,.76-.749V31.7A.749.749,0,0,0,51.875,30.947ZM37.641,33.393a.239.239,0,0,1,.246-.242h9.079a.249.249,0,0,1,.257.242V44.785a.258.258,0,0,1-.257.253H37.887a.249.249,0,0,1-.246-.253Zm.526.275H46.7V44.51H38.166ZM36.2,34.12V46.967a.756.756,0,0,0,.76.749H48.475V30.947H39.34a3.232,3.232,0,0,0-2.192.926,3.134,3.134,0,0,0-.939,2.237Zm13.619-.981H51.83v5.6H49.817Z",
    transform: "translate(-26.571 -22.716)",
    fill: "#c21618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_793",
    "data-name": "Caminho 793",
    d: "M27.288,18.812a3.759,3.759,0,0,0-3.79,3.735,3.469,3.469,0,0,0-.045-.595,3.754,3.754,0,0,0-3.735-3.129,3.743,3.743,0,0,0,3.779-3.7A3.736,3.736,0,0,0,25.991,18.6a3.907,3.907,0,0,0,1.3.22Z",
    transform: "translate(-14.474 -11.1)",
    fill: "#c21618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_794",
    "data-name": "Caminho 794",
    d: "M18.908,2.5A2.542,2.542,0,0,0,16.359,5a2.515,2.515,0,0,0-2.527-2.5A2.523,2.523,0,0,0,16.359,0,2.542,2.542,0,0,0,18.908,2.5Z",
    transform: "translate(-10.153)",
    fill: "#c21618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_795",
    "data-name": "Caminho 795",
    d: "M5.971,14.613H5.747a.876.876,0,0,0-.168.022.874.874,0,0,0-.168.022H5.356l-.078.033-.078.022a.777.777,0,0,0-.19.055H4.987a.753.753,0,0,1-.19.077c-.034.022-.078.033-.112.055a2.914,2.914,0,0,0-.559.342c-.034.033-.089.077-.145.121l-.022.022s-.056.066-.089.1l-.056.055c-.056.055-.089.1-.145.154l-.168.231c-.034.077-.089.154-.134.242-.034.044-.056.088-.078.121-.034.088-.078.176-.112.264a1.317,1.317,0,0,0-.089.275c-.022.1-.034.187-.056.286,0,.066-.022.132-.022.209v.022a.739.739,0,0,0-.022.22A2.963,2.963,0,0,0,0,14.624a2.956,2.956,0,0,0,2.985-2.942.7.7,0,0,0,.022.22v.022c0,.066.022.143.022.209.022.1.034.187.056.286a2.633,2.633,0,0,0,.089.275c.034.088.078.176.112.264a.285.285,0,0,0,.078.121,1.694,1.694,0,0,0,.134.242c.056.077.112.154.168.22l.168.165.034.044s.089.088.145.132a.3.3,0,0,0,.089.077.3.3,0,0,0,.089.077,1.4,1.4,0,0,0,.19.132l.034.022a.763.763,0,0,0,.19.1c.078.033.145.066.224.1s.134.055.2.077h.056a.653.653,0,0,0,.19.066H5.3a2.7,2.7,0,0,0,.66.077Z",
    transform: "translate(0 -8.576)",
    fill: "#c21618"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72);
export default __webpack_public_path__ + "static/media/72+.4ed3b4bfb9c41f67458e03745eac5aa4.svg";
export { ForwardRef as ReactComponent };